import { MetricData } from '../../performance-data/metric.pd.model';
import { ColourGroup } from '../models/colour-group.model';
import { MetricItem } from '../models/metric-item.model';

export function getColourGroup(populationMetrics: MetricData[]): ColourGroup[] {
    const colourGroups: ColourGroup[] = [];
    const tempObject = {};

    populationMetrics[0]?.metrics.forEach((m) => {
        const color = m.targetThresholdColor;
        const metrics = populationMetrics[0].metrics
            .filter((ee) => ee.targetThresholdColor === m.targetThresholdColor)
            .map<MetricItem>((item) => {
                return {
                    performanceViewTypeId: undefined,
                    metricName: item.name,
                    actual: item.actual,
                    target: item.target,
                };
            });
        tempObject[color] = metrics;
    });
    Object.keys(tempObject).forEach((ee) => {
        colourGroups.push({ colour: ee, metrics: tempObject[ee] });
    });
    return colourGroups;
}
